import { handleActions } from 'redux-actions';
import { setEmailAccount } from '../actions/emailActions';

const defaultState = {
  emailAccount: null,
};

export default handleActions(
  {
    [setEmailAccount](state, action) {
      return { ...state, emailAccount: action.payload };
    },
  },
  defaultState
);
